module.exports = __webpack_public_path__ + "static/media/15.f1033821.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairback/15.png
// module id = 652
// module chunks = 0